<template>
  <div class="p_demand_info">
    <div class="mapContainer" v-show="visibleMap" ref="chickMap" :style="[{top:marY + 'px'},{left:marX + 'px'}]">
      <div id="mapSelector" style="width: 600px; height: 300px"></div>
    </div>
    <div class="r_info_dtl">
      <p v-if="proDtl.StrservuserNname">
        <span>客服：</span>
        <span>{{ proDtl.ServiceDepName ? proDtl.ServiceDepName + "/" : ""
          }}{{ proDtl.StrservuserNname ? proDtl.StrservuserNname + "/" : ""
          }}{{ proDtl.StrservuserMobile ? proDtl.StrservuserMobile : "" }}</span>
      </p>
      <p v-if="proDtl.StrProManagerName">
        <span>项目管理员：</span>
        <span>{{ proDtl.StrProManagerName ? proDtl.StrProManagerName + "/" : ""
          }}{{ proDtl.StrProManagerName ? proDtl.StrProManagerName : "" }}</span>
      </p>
    </div>
    <div class="info_Item">
      <div class="flex sb">
        <div class="flex f_form" style="margin-bottom: 10px">
          <div class="info_Item_Title">基本信息</div>
          <div class="p_plan_item"></div>
        </div>
        <!-- <div style="padding-right: 100px;">
          <div v-show="projectpersondetails.StrservuserNname">客服：{{ projectpersondetails.ServiceDepName + '/'+ projectpersondetails.StrservuserNname + '/' + projectpersondetails.StrservuserMobile }}</div>
          <div v-show="projectpersondetails.StrAchieveownerName">业务员：{{ projectpersondetails.StrbusdepName + '/'+ projectpersondetails.StrAchieveownerName + '/' + projectpersondetails.StrAchieveownerMobile }}</div>
          <div v-show="projectpersondetails.StrProManagerName">运营：{{ projectpersondetails.StrProManagerDep + '/'+ projectpersondetails.StrProManagerName + '/' + projectpersondetails.StrProManagerMobile }}</div>
        </div> -->
      </div>
      <div class="demandForm">
        <el-form :model="query" :disabled="isEdit == 'look'" :rules="rules" ref="ruleForm" :inline="true" label-width="120px">
          <el-form-item label="项目名称：" prop="ProjectId">
            <el-select @change="selectPro" filterable clearable v-model="query.ProjectId" :disabled="
                query.StrPlanstatus != '待招聘' && query.StrPlanstatus != ''
              " placeholder="请选择">
              <el-option v-for="item in prolist" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
            </el-select>
            <!-- <el-autocomplete v-model="projectname" popper-class="search-autocpmplete" ref="pro" :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false" :debounce="10" value-key="StrprojectName" value="Projectid" @select="handleSelect"></el-autocomplete> -->
          </el-form-item>

          <el-form-item label="劳动关系：" prop="LaborRelation">
            <el-select @change="selectChange" filterable v-model="query.LaborRelation" placeholder="请选择">
              <el-option v-for="item in labour" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="岗位属性：" prop="JobType">
            <el-select filterable @change="selectChange" v-model="query.JobType" placeholder="请选择">
              <el-option label="长期工" value="长期工"></el-option>
              <el-option label="临时工" value="临时工"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="岗位类型：" prop="JobCategory">
            <el-cascader :options="jobCategoryList" ref="cascader" filterable :show-all-levels="false" v-model="query.JobCategory" @change="changeJob" :props="{
                checkStrictly: true,
                value: 'strParametername',
                label: 'strParametername',
              }" :disabled="
                query.StrPlanstatus != '待招聘' && query.StrPlanstatus != ''
              "></el-cascader>
          </el-form-item>

          <el-form-item label="岗位名称：" prop="CustomerJobName">
            <el-input v-model="query.CustomerJobName" :disabled="!query.ProjectId || !query.JobCategory"></el-input>
          </el-form-item>

          <el-form-item label="班次：" prop="WorkingShift">
            <el-select @change="selectChange" filterable v-model="query.WorkingShift" placeholder="请选择">
              <el-option v-for="item in classes" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="站/坐班：" prop="Workingposition">
            <div class="Workingposition">
              <el-radio-group v-model="query.Workingposition">
                <el-radio v-for="item in posture" :key="item.Id" :label="item.Name"></el-radio>
              </el-radio-group>
            </div>
          </el-form-item>

          <el-form-item label="需求人数：" prop="NeedAmount">
            <div class="age flex">
              <el-input v-model="query.NeedAmount" type="number"></el-input>
              <el-upload style="margin-left: 10px" class="p_plan_upload" action="#" :on-change="handleChangeDemFile" :on-remove="handleRemoveDemFile" :auto-upload="false" :multiple="false" :limit="1" :on-exceed="handleExceed" :file-list="DemfileList">
                <el-button size="small" type="text">上传附件</el-button>
              </el-upload>
            </div>
          </el-form-item>

          <!-- <el-form-item label="需求附件：">
            <el-upload class="p_plan_upload" action="#" :on-change="handleChangeDemFile" :on-remove="handleRemoveDemFile" :auto-upload="false" :multiple="false" :limit="1" :on-exceed="handleExceed" :file-list="DemfileList">
              <el-button size="small" type="text">点击上传</el-button>
            </el-upload>
          </el-form-item> -->

          <el-form-item label="工作城市：" prop="workCity">
            <div class="address">
              <el-cascader :props="propsCity" ref="workCity" v-model="workCity" :options="provinces" @change="changeCity"></el-cascader>
            </div>
          </el-form-item>

          <!-- <el-form-item label="杰伴岗位：" prop="AppleJob">
            <el-input v-model="query.AppleJob" :disabled="!query.ProjectId || !query.JobCategory"></el-input>
          </el-form-item> -->

          <div class="textarea">
            <el-form-item style="width: 100%" label="工作内容：" prop="JobContent">
              <el-input type="textarea" :rows="3" v-model="query.JobContent" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </div>

          <!-- 基本信息 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            任职要求
          </div>

          <el-form-item label="性别：" prop="Gender">
            <el-select @change="selectChange" v-model="query.Gender" placeholder="请选择">
              <el-option v-for="item in sex" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="年龄：" prop="age">
            <div class="age flex">
              <el-input v-model="query.AgeReqStart" type="number" onkeyup="this.value = this.value.replace(/[^A-z0-9]/, '')"></el-input>
              <span class="crossbar">~</span>
              <el-input v-model="query.AgeReqEnd" type="number" onkeyup="this.value = this.value.replace(/[^A-z0-9]/, '')"></el-input>
            </div>
          </el-form-item>

          <el-form-item label="证书要求：">
            <!-- <el-select @change="selectChange" v-model="query.CertificateRequirements" placeholder="请选择">
              <el-option v-for="item in certificate" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select> -->
            <div class="certificate">
              <el-cascader :options="certificate" ref="certificate" :show-all-levels="false" v-model="CertificateRequirements" @change="changeCert" collapse-tags :props="{ multiple: true, value: 'Name', label: 'Name' }" clearable placeholder=""></el-cascader>
            </div>
          </el-form-item>

          <el-form-item label="工作经验要求：" prop="ExperienceReq">
            <el-select @change="selectChange" v-model="query.ExperienceReq" placeholder="请选择">
              <el-option v-for="item in workExp" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="民族(可多选)：" prop="NationalityRequire">
            <!-- <el-checkbox-group v-model="query.NationalityRequire">
              <el-checkbox v-for="item in nation" :key="item.Id" :label="item.Name" name="type" @change="changeNav">{{item.Name}}</el-checkbox>
            </el-checkbox-group> -->
            <el-select @change="selectChange" collapse-tags multiple filterable v-model="query.NationalityRequire" placeholder="请选择">
              <el-option v-for="item in nation" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学历：" prop="Degree">
            <div class="Degree Degree1 flex">
              <el-select @change="selectChange" v-model="query.Degree" placeholder="请选择">
                <el-option v-for="item in edu" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
              <!-- <el-radio-group style="margin-left: 10px;" v-model="query.Degree1">
              <el-radio v-for="(item,index) in moreEdu" :key="index" :label="item"></el-radio>
            </el-radio-group> -->
              <el-checkbox-group @change="selectChange" v-model="query.Degree1" style="margin-left: 10px">
                <el-checkbox v-for="item in moreEdu" :key="item.Id" :label="item" name="type">{{ item }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>

          <el-form-item>
            <!-- <el-radio-group v-model="query.AcceptDisabled">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group> -->
            <div class="flex" prop="AcceptDisabled">
              <el-checkbox v-model="query.AcceptDisabled">接受残疾人</el-checkbox>
              <el-input style="margin-left: 10px" v-model="query.AcceptDisabledRemark" placeholder="接受残疾人备注" maxlength="255"></el-input>
            </div>
          </el-form-item>

          <div style="display: inline-block">
            <div v-for="(item, index) in query.LimitProvinceName" :key="index" class="mulLimitProvinceName">
              <el-form-item :label="'限制地区' + Number(index + 1) + '：'" :prop="'LimitProvinceName.' + index + '.name'">
                <el-cascader :props="propsCity" ref="LimitProvinceName" v-model="[item].name" :options="provinces" @change="changeLimitProvinceName(index)" clearable>
                </el-cascader>
                <el-button @click.prevent="removeLimitProvinceName(index)" type="danger" v-if="index != 0" style="margin-left: 10px; padding: 8px 20px">删除</el-button>
              </el-form-item>
            </div>
            <div class="addnewdepart cp" @click="addLimitProvinceName">
              +添加限制地区
            </div>
          </div>

          <!-- <el-form-item label="接受残疾人备注：">

          </el-form-item> -->

           <!-- 工作时间 -->
           <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            工作时间
          </div>

          <!-- <el-form-item label="作息时间：">
            <el-input v-model="query.Timetable"></el-input>
          </el-form-item> -->
          <el-form-item style="margin-left: 15px">
            <el-checkbox v-model="query.IsOverTime">需要加班</el-checkbox>
          </el-form-item>

          <!-- <el-form-item label="需要加班：">
            <el-select @change="selectChange" v-model="query.IsOverTime" placeholder="请选择">
              <el-option v-for="item in workOvertime" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item> -->

          <!-- <el-form-item label="可否固定班次：">
            <el-select @change="selectChange" v-model="query.IsFixedCaclss" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="排班周期：" prop="CycleTimetable">
            <el-input v-model="query.CycleTimetable"></el-input>
          </el-form-item>

          <el-form-item label="月休：" prop="MonthlyRest">
            <el-input v-model="query.MonthlyRest"></el-input>
          </el-form-item>

          <div class="AttendanceTime">
            <div v-for="(item, index) in query.AttendanceTime" :key="index" v-if="typeof query.AttendanceTime == 'object'">
              <el-form-item :label="'上班时间' + Number(index + 1) + '：'" :prop="'AttendanceTime.' + index + '.endTime'" :rules="{
                  required: true,
                  message: '请选择完整的上班时间',
                  trigger: 'change',
                }">
                <!-- <el-time-picker is-range v-model="item.timeSlot" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" :picker-options="{ step: '00:30'}">
                </el-time-picker> -->
                <div class="flex">
                  <el-time-select v-model="item.startTime" :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '24:00',
                    }" placeholder="选择时间">
                  </el-time-select>
                  <span class="zhi">至</span>
                  <el-time-select v-model="item.endTime" :picker-options="{
                      start: '00:00',
                      step: '00:30',
                      end: '24:00',
                    }" placeholder="选择时间"></el-time-select>
                  <el-button @click.prevent="removeAttendanceTime(index)" type="danger" v-if="index != 0" style=" margin-left: 10px;padding: 0 20px; height: 32px;line-height: 32px; margin-top: 4px; ">删除</el-button>
                </div>
              </el-form-item>
            </div>
            <div class="addnewdepart cp" @click="addAttendanceTime">
              +添加上班时间
            </div>
          </div>

          <!-- 薪资福利（明细） -->
          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            薪资福利（明细）
          </div>
          <el-form-item label="薪资类型：" prop="PayType">
            <el-select @change="selectChange" v-model="query.PayType" placeholder="请选择">
              <el-option v-for="item in salaryType" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发薪方式：" prop="MethodOfPay">
            <el-select @change="selectChange" v-model="query.MethodOfPay" placeholder="请选择">
              <el-option v-for="item in methodOfPay" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="正式薪资标准：" prop="SalaryAfterFullEmployment">
            <div class="unitPrice flex">
              <el-input type="number" v-model="query.SalaryAfterFullEmployment"></el-input>
              <el-select @change="selectChange" style="margin-left: 10px" v-model="query.SalaryAfterFullEmploymentUnit">
                <el-option v-for="item in unit" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="试用期薪资标准：" prop="SalaryduringProbationPeriod" label-width="130px">
            <div class="unitPrice flex">
              <el-input type="number" v-model="query.SalaryduringProbationPeriod"></el-input>
              <el-select @change="selectChange" style="margin-left: 10px" v-model="query.SalaryduringProbationPeriodUnit">
                <el-option v-for="item in unit" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="综合薪资：" prop="ComprehensiveSalary">
            <div class="age flex">
              <el-input type="number" v-model="query.ComprehensiveSalary" onkeyup="this.value = this.value.replace(/[^A-z0-9]/, '')"></el-input>
              <span class="crossbar">~</span>
              <el-input type="number" v-model="query.ComprehensiveSalaryEnd" onkeyup="this.value = this.value.replace(/[^A-z0-9]/, '')"></el-input>
            </div>
          </el-form-item>

          <el-form-item label="发薪日：" prop="PayDate">
            <div class="age flex" style="width: 150px">
              <el-input v-model="query.PayDate" onkeyup="this.value = this.value.replace(/[^A-z0-9]/, '')"></el-input>
              <div class="PayDateUnit">号</div>
            </div>
          </el-form-item>

          <el-form-item label="无薪资周期：" prop="UnpaidPeriod">
            <div class="age flex" style="width: 150px">
              <el-input v-model="query.UnpaidPeriod"></el-input>
              <div class="UnpaidPeriodUnit">天</div>
            </div>
          </el-form-item>

          <el-form-item label="无薪资备注：" prop="UnpaidPeriodRemark">
            <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 2}" v-model="query.UnpaidPeriodRemark" maxlength="500" show-word-limit></el-input>
          </el-form-item>

          <div>
            <el-form-item label="是否包住：" prop="IncludeStay">
              <el-select @change="selectChange" v-model="query.IncludeStay" placeholder="请选择">
                <el-option v-for="item in stay" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否包吃：" prop="PackageEat">
              <el-select @change="selectChange" v-model="query.PackageEat" placeholder="请选择">
                <el-option v-for="item in eat" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="食宿备注：" prop="IncludeStayEatRemark">
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 2}" v-model="query.IncludeStayEatRemark" maxlength="500" show-word-limit></el-input>
            </el-form-item>

            <el-form-item label="是否交通车：" prop="ThroughTrainNot">
              <el-select v-model="query.ThroughTrainNot" placeholder="请选择">
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div>
            <el-form-item label="夜班补贴：" prop="NightShiftSubsidy">
              <el-input v-model="query.NightShiftSubsidy"></el-input>
            </el-form-item>

            <el-form-item label="加班补贴：" prop="OvertimeSubsidy">
              <el-input v-model="query.OvertimeSubsidy"></el-input>
            </el-form-item>

            <div>
              <el-form-item label="社保缴纳方式：" prop="SocialSecurityPaymentMethod" label-width="125px">
                <!-- <el-radio v-for="item in sspm" :key="item.Id" v-model="query.SocialSecurityPaymentMethod" :label="item.Name"></el-radio> -->
                <el-select @change="selectChange" v-model="query.SocialSecurityPaymentMethod" placeholder="请选择">
                  <el-option v-for="item in sspm" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="社保备注：" prop="SsPaymentMethodRemark">
                <div class="mintextarea">
                  <el-input type="textarea" :rows="3" v-model="query.SsPaymentMethodRemark" maxlength="500" show-word-limit></el-input>
                </div>
              </el-form-item>
            </div>

            <el-form-item label="公积金缴纳方式：" prop="AccumulationFundPaymentMethod" label-width="125px">
              <!-- <el-radio v-for="item in gjj" :key="item.Id" v-model="query.AccumulationFundPaymentMethod" :label="item.Name"></el-radio> -->
              <el-select @change="selectChange" v-model="query.AccumulationFundPaymentMethod" placeholder="请选择">
                <el-option v-for="item in gjj" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公积金备注：" prop="PfPaymentMethodRemark">
                <div class="mintextarea">
                  <el-input type="textarea" :rows="3" v-model="query.PfPaymentMethodRemark" maxlength="500" show-word-limit></el-input>
                </div>
              </el-form-item>
          </div>

          <!-- <el-form-item label="底薪：">
            <el-input v-model="query.BasicSalary"></el-input>
          </el-form-item> -->

          <!-- <el-form-item label="暂支标准：">
            <div class="flex">
              <el-input v-model="query.TemporarySupportStandard"></el-input>
              <el-checkbox style="margin-left: 20px;" v-model="query.IsAdvanceAccount" :true-label="1" :false-label="0">可暂支</el-checkbox>
            </div>
          </el-form-item> -->

          <!-- <el-form-item label="薪资说明：">
            <el-input type="textarea" autosize v-model="query.DescriptionofSalary"></el-input>
          </el-form-item> -->
          <div class="textarea">
            <el-form-item style="width: 100%" label="备注：" prop="CompensationAndWelfareRemark">
              <el-input type="textarea" :rows="2" v-model="query.CompensationAndWelfareRemark" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </div>

          <div class="WorkAndDormitoryEnvironment">
            <el-form-item label="工作&宿舍环境：" style="display: block">
              <el-upload action="" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemovePic" :on-change="handleChangePic" :on-exceed="handleExceedPic" :auto-upload="false" :multiple="false" :limit="9" :file-list="PicList">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisiblePic">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </div>

          <!-- <el-form-item label="其他要求：">
            <el-input type="textarea" autosize v-model="query.OtherBenefits"></el-input>
          </el-form-item> -->


          <!-- 培训晋升 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            培训/试工
          </div>

          <div class="TrainCycle">
            <el-form-item label="培训周期：" prop="TrainCycle">
              <div class="mintextarea">
                <el-input type="textarea" :rows="2" v-model="query.TrainCycle" maxlength="500" show-word-limit></el-input>
              </div>
            </el-form-item>

            <el-form-item style="margin-left: 15px">
              <el-checkbox v-model="query.PayforTraining">培训有薪资</el-checkbox>
            </el-form-item>
          </div>

          <div class="TrainCycle" style="margin-top: 10px">
            <el-form-item label="试工周期：" prop="Trialperiod">
              <div class="mintextarea">
                <el-input type="textarea" :rows="2" v-model="query.Trialperiod" maxlength="500" show-word-limit></el-input>
              </div>
            </el-form-item>

            <el-form-item style="margin-left: 15px">
              <el-checkbox v-model="query.TrialWorkisPaid">试工有薪资</el-checkbox>
            </el-form-item>
          </div>

          <!-- <el-form-item label="培训是否淘汰：">
            <el-select @change="selectChange" v-model="query.TrainingIsObsolete" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否有晋升：">
            <el-select @change="selectChange" v-model="query.HavePromotion" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item> -->

          <!-- 优点/缺点 -->
          <!-- <div class="info_Item_Title f_form" style="margin-bottom: 10px;">优点/缺点</div>

          <el-form-item label="优点描述：">
            <el-input type="textarea" autosize v-model="query.DescriptionAdvantages"></el-input>
          </el-form-item>

          <el-form-item label="缺点描述：">
            <el-input type="textarea" autosize v-model="query.DescriptionDisadvantages"></el-input>
          </el-form-item> -->

          <!-- 面试信息 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            面试信息
          </div>

          <el-form-item label="面试地址详情：" prop="InterviewAddress">
            <div class="address flex" ref="chickBox">
              <el-cascader ref="InterviewAddress" :props="propsAddress" v-model="interAddress" :options="provinces" :disabled="interviewOnline" @change="changeInterviewArae"></el-cascader>
              <span class="locateSplit">/</span>

              <div style="position: relative;">
                <el-input id="locDetail" v-model="query.InterviewAddress" type="text" placeholder="详细地址" autocomplete="off" @blur="blurSearch('inter')" :disabled="interviewOnline"></el-input>
                <div v-show="showAddressSelect" class="addressSelect">
                  <div v-for="(item,index) in addressList" :key="index" class="addressSelectItem cp" @click.stop="selectInterviewAddress(item)">
                    <span>{{ item.title }}</span>
                    <span class="remake" v-if="item.province!=undefined && item.province">{{item.province}}-{{item.city}}-{{item.district}}</span>
                  </div>
                  <div v-if="addressList.length==0" class="empty">
                    暂无匹配项
                  </div>
                </div>
              </div>
              <!-- <el-button slot="reference" size="small" type="success" class="locDetailSeach" @click="querySearch(query.InterviewAraeName,query.InterviewAddress,'inter',$event)" style="margin-right: 10px" :disabled="interviewOnline">搜索</el-button> -->

              <el-checkbox v-model="interviewOnline" @change="changeInterviewOnline">线上面试</el-checkbox>

              <div class="flex" style="margin-left: 20px;">
                <div class="p_plan_title" style="width: 35px">附件:</div>
                <div class="p_plan_right">
                  <el-upload class="p_plan_upload" action="#" :on-change="handleChangeInterview" :on-remove="handleRemoveInterview" :auto-upload="false" :multiple="false" :limit="1" :on-exceed="handleExceed" :file-list="InterviewfileList">
                    <el-button size="small" type="text">点击上传</el-button>
                  </el-upload>
                </div>
              </div>
              <!-- <div>
                <el-popover placement="top" width="600" trigger="manual" v-model="visibleMap" z-index="9999">
                  <div class="mapContainer">
                    <div id="mapSelector" style="width: 600px; height: 300px"></div>
                  </div>
                  <el-button slot="reference" type="text" v-show="query.InterviewArae" @click="visibleMap = !visibleMap"> <i class="el-icon-location"></i>{{visibleMap ? '关闭' : '查看'}}地图信息</el-button>
                </el-popover>
              </div> -->
            </div>
          </el-form-item>

          <!-- <el-form-item label="面试交通路线：">
            <el-input v-model="query.InterviewTransportation"></el-input>
          </el-form-item>

          <el-form-item label="工作地点交通路线：" label-width="126px">
            <el-input v-model="query.WorkTransportation"></el-input>
          </el-form-item> -->

          <div class="TrainCycle">
            <el-form-item label="面试流程：" prop="InterviewProcess">
              <div class="mintextarea">
                <el-input type="textarea" :rows="3" v-model="query.InterviewProcess" maxlength="500" show-word-limit></el-input>
              </div>
            </el-form-item>

            <el-form-item label="面试注意事项：" prop="InterviewTips">
              <div class="mintextarea">
                <el-input type="textarea" :rows="3" v-model="query.InterviewTips" maxlength="500" show-word-limit></el-input>
              </div>
            </el-form-item>
          </div>
          <!-- 入职信息 -->
          <div class="info_Item_Title f_form" style="margin-bottom: 10px">
            入职信息
          </div>

          <!-- <el-form-item label="入职周期：">
            <el-input v-model="query.PeriodEntry"></el-input>
          </el-form-item> -->

          <el-form-item label="是否需要押金：" prop="IsNeedDeposit">
            <el-select @change="selectChange" v-model="query.IsNeedDeposit" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="押金类型：">
            <div class="DepositType age Degree flex">
              <!-- <el-radio-group v-model="query.DepositType">
                <el-radio :label="'住宿'">住宿</el-radio>
                <el-radio :label="'劳保'">劳保</el-radio>
                <el-radio :label="'饭卡'">饭卡</el-radio>
                <el-radio :label="'其他'">其他</el-radio>
              </el-radio-group> -->
              <el-checkbox-group v-model="query.DepositType">
                <el-checkbox v-for="item in DepositTypeList" :key="item.Id" :label="item" name="type" @change="changeNav">{{ item }}</el-checkbox>
              </el-checkbox-group>
              <el-checkbox v-model="otherDepositType">其他</el-checkbox>
              <el-input v-if="otherDepositType" v-model="DepositType"></el-input>
            </div>
          </el-form-item>

          <el-form-item label="押金说明：">
            <el-input v-model="query.DepositExplain"></el-input>
          </el-form-item>

          <div>
            <el-form-item label="是否需要体检：" prop="MedicalExaminationReq">
              <el-select @change="selectChange" v-model="query.MedicalExaminationReq" placeholder="请选择">
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="否"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="体检类型：">
              <el-select @change="selectChange" v-model="query.TypeofPhysicalExamination" placeholder="请选择">
                <el-option label="常规体检" value="常规体检"></el-option>
                <el-option label="职业病体检" value="职业病体检"></el-option>
                <el-option label="健康证" value="健康证"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="体检金额：" prop="AmountofPhysicalExamination">
              <div class="UnpaidPeriod flex">
                <el-input v-model="query.AmountofPhysicalExamination"></el-input>
                <div class="UnpaidPeriodUnit">元</div>
              </div>
            </el-form-item>

            <el-form-item label="体检医院：">
              <el-input v-model="query.MedicalExaminationHospita"></el-input>
            </el-form-item>

            <el-form-item label="体检费：" prop="PhysicalExaminationFee">
              <!-- <el-select @change="selectChange" v-model="query.PhysicalExaminationFee" placeholder="请选择">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select> -->
              <el-radio-group v-model="query.PhysicalExaminationFee">
                <el-radio :label="'报销'">报销</el-radio>
                <el-radio :label="'不报销'">不报销</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="报销说明：">
              <el-input v-model="query.MedicalExaminationrReimbursementStatement"></el-input>
            </el-form-item>
          </div>

          <!-- <el-form-item label="报销条件/时间：">
            <el-input v-model="query.PhysicalExaminationFeeCondition"></el-input>
          </el-form-item> -->

          <el-form-item label="上班地址：" prop="workAddress">
            <div class="address flex" ref="chickBox1">
              <el-cascader ref="workAddress" :props="propsAddress" v-model="workAddress" :options="provinces" @change="changeWorkArea"></el-cascader>
              <span class="locateSplit">/</span>
              <!-- <el-input id="locDetail" v-model="query.EntryAddress" type="text" placeholder="详细地址" autocomplete="off"></el-input>
              <el-button size="small" type="success" class="locDetailSeach" style="margin-right: 10px">搜索</el-button> -->
              <div style="position: relative;">
                <el-input id="locDetail" v-model="query.EntryAddress" type="text" placeholder="详细地址" autocomplete="off" @blur="blurSearch('work')"></el-input>
                <div v-show="showAddressSelect2" class="addressSelect">
                  <div v-for="(item,index) in addressList" :key="index" class="addressSelectItem cp" @click.stop="selectInterviewAddress(item)">
                    <span>{{ item.title }}</span>
                    <span class="remake" v-if="item.province!=undefined && item.province">{{item.province}}-{{item.city}}-{{item.district}}</span>
                  </div>
                  <div v-if="addressList.length==0" class="empty">
                    暂无匹配项
                  </div>
                </div>
              </div>
              <!-- <el-button slot="reference" size="small" type="success" class="locDetailSeach" @click="querySearch(query.EntryCity,query.EntryAddress,'work',$event)" style="margin-right: 10px">搜索</el-button> -->
              <!-- <div>
                <el-popover placement="top" width="600" trigger="manual" v-model="visibleMap2" z-index="9999">
                  <div class="mapContainer">
                    <div id="mapSelector" style="width: 600px; height: 300px"></div>
                  </div>
                  <el-button slot="reference" size="small" type="success" class="locDetailSeach" @click="querySearch(query.EntryCity,query.EntryAddress,'work')" style="margin-right: 10px">搜索</el-button>
                </el-popover>
              </div> -->
              <div class="flex">
                <div class="p_plan_title" style="width: 35px">附件:</div>
                <div class="p_plan_right">
                  <el-upload class="p_plan_upload" action="#" :on-change="handleChangeAddress" :on-remove="handleRemoveAddress" :auto-upload="false" :multiple="false" :limit="1" :on-exceed="handleExceed" :file-list="addressfileList">
                    <el-button size="small" type="text">点击上传</el-button>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-form-item>

          <div style="display: block" class="TrainCycle">
            <el-form-item label="入职流程/注意事项：" label-width="150px" prop="ProcessTip">
              <div class="mintextarea">
                <el-input type="textarea" :rows="3" v-model="query.ProcessTip" maxlength="500" show-word-limit></el-input>
              </div>
            </el-form-item>

            <el-form-item label="体检流程/注意事项：" label-width="150px" prop="ProcedurePhysicalExamination">
              <div class="mintextarea">
                <el-input type="textarea" :rows="3" v-model="query.ProcedurePhysicalExamination" maxlength="500" show-word-limit></el-input>
              </div>
            </el-form-item>
          </div>

          <div class="btnBox">
            <el-button type="success" @click="submitForm">下一步</el-button>
            <el-button @click="backHandle">取消</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  import moment from "moment";
  export default {
    name: "recruitPlan",
    props: {
      Id: {
        type: String,
        default: "",
      },
    },
    data() {
      // var validatetPro = (rule, value, callback) => {
      //   if (!this.projectname) {
      //     callback(new Error('请选择项目'));
      //   } else if (this.prolist.length == 0 && this.isEdit == '') {
      //     callback(new Error('暂无匹配项目'));
      //   } else if (!this.query.ProjectId) {
      //     callback(new Error('请从下拉选项中选择项目'));
      //   } else {
      //     callback()
      //   }
      // }
      var validatetJobName = (rule, value, callback) => {
        if (!this.query.CustomerJobName) {
          callback(new Error("请输入岗位名称"));
        } else {
          this.checkJobName(value, (res) => {
            console.log(res);
            if (res) {
              callback();
            } else {
              callback(new Error("岗位名称已存在"));
            }
          });
        }
      };
      var validatetAge = (rule, value, callback) => {
        if (!this.query.AgeReqStart || !this.query.AgeReqEnd) {
          callback(new Error("请输入年龄要求"));
        } else {
          callback();
        }
      };
      var validatetEntryAttachmentFileName = (rule, value, callback) => {
        if (!this.workAddress) {
          callback(new Error("请选择上班地区"));
        } else if (!this.query.EntryAddress) {
          callback(new Error("请输入上班详细地址"));
        } else {
          callback();
        }
      };
      var validatetInter = (rule, value, callback) => {
        if (this.interviewOnline) {
          callback();
        } else {
          if (!this.query.InterviewProvince) {
            callback(new Error("请选择面试地区"));
          } else if (!this.query.InterviewAddress) {
            callback(new Error("请输入详细地址"));
          } else {
            callback();
          }
        }
      };
      var validatetSalary = (rule, value, callback) => {
        if (this.query.ComprehensiveSalary < 0 || this.query.ComprehensiveSalaryEnd < 0) {
          callback(new Error("不能输入负数"));
        } else if (this.query.ComprehensiveSalary.toString().indexOf(".") > -1 || this.query.ComprehensiveSalaryEnd.toString().indexOf(".") > -1) {
          callback(new Error("请输入正整数"));
        } else if (
          !this.query.ComprehensiveSalary ||
          !this.query.ComprehensiveSalaryEnd
        ) {
          callback(new Error("请输入完整的综合薪资"));
        } else {
          callback();
        }
      };
      var validatetCert = (rule, value, callback) => {
        if (!this.CertificateRequirements) {
          callback(new Error("请选择证书要求"));
        } else {
          callback();
        }
      };
      var validatetCity = (rule, value, callback) => {
        if (!this.workCity) {
          callback(new Error("请选择工作城市"));
        } else {
          callback();
        }
      };
      return {
        // 项目详情
        proDtl: {
          StrProManagerName: "", // 项目管理员
          StrProManagerMobile: "",
          StrservuserNname: "", // 客服
          StrservuserMobile: "",
          ServiceDepName: "", // 服务中心
        },
        visibleMap: false, //展示地图
        //岗位描述附件
        JobDesfileList: [],
        DemfileList: [], //需求附件
        addressfileList: [], //工作地址附件
        prolist: [],
        projectname: "",
        jobCategoryList: [], //岗位类别列表
        edu: [], //学历要求
        workExp: [], //工作经验要求
        stay: [], //是否包住
        sex: [], //岗位性别
        sspm: [], //社保缴纳方式
        gjj: [], //公积金缴纳方式
        eat: [], //是否包吃
        workOvertime: [], //是否加班
        posture: [], //站班和坐班
        classes: [], //班次
        nation: [], //民族要求
        certificate: [], //证书
        unit: [], // 薪资单位
        salaryType: [], //薪资类型
        labour: [], //劳动关系
        moreEdu: ["会写名字", "识字", "认识26字母"],
        DepositTypeList: ["住宿", "劳保", "饭卡"], //押金类型类别
        methodOfPay: [], //发薪方式
        DepositType: [], //其他押金类型
        otherDepositType: false,
        CertificateRequirements: [], //选择的证书
        query: {
          Id: "",
          ProjectId: "",
          LaborRelation: "",
          StrPlanstatus: "",
          JobType: "",
          JobCategory: "",
          CustomerJobName: "",
          NeedAmount: "",
          AppleJob:"",
          DemandAttachment: "",
          DemandAttachmentFileName: "",
          WorkCity: [],
          workProvince: "",
          WorkAreaName: "",
          EntryAttachmentFileName: "",
          JobContent: "",
          Degree: "",
          Degree1: [], //学历附加条件
          AcceptDisabled: "", //接受残疾人
          AcceptDisabledRemark: "", //接受残疾人备注
          LimitProvinceName: [{
            name: "",
          }], //限制地区
          MethodOfPay: "", //发薪方式
          IncludeStayEatRemark: "", //食宿备注
          UnpaidPeriod: "", //无薪资周期
          UnpaidPeriodRemark: "", //无薪资备注
          NightShiftSubsidy: "", //夜班补贴
          OvertimeSubsidy: "", //加班补贴
          AccumulationFundPaymentMethod: "", //公积金缴纳方式
          AttendanceTime: [{
            startTime: "",
            endTime: "",
          }], //上班时间
          ComprehensiveSalary: "", //综合薪资
          ComprehensiveSalaryEnd: "", //综合薪资
          PayforTraining: "", //培训有薪资
          TrialWorkisPaid: "", //试工有薪资
          DepositType: [], //押金类型
          MonthlyRest: "", //月休
          DepositExplain: "", //押金说明
          TypeofPhysicalExamination: "", //体检类型
          AmountofPhysicalExamination: "", //体检金额
          MedicalExaminationrReimbursementStatement: "", //报销说明
          Gender: "",
          AgeReqStart: "",
          AgeReqEnd: "",
          ExperienceReq: "",
          OtherReq: "",
          SalaryAfterFullEmployment: "",
          SalaryAfterFullEmploymentUnit: "元/月",
          IsAdvanceAccount: 0,
          SalaryduringProbationPeriod: "",
          SalaryduringProbationPeriodUnit: "元/月",
          trainingPeriodSalary: "",
          PackageEat: "",
          SocialSecurityPaymentMethod: "",
          PayDate: "",
          Timetable: "",
          CycleTimetable: "",
          IsFixedCaclss: "",
          IsOverTime: "",
          TrainCycle: "",
          TrainingIsObsolete: "",
          HavePromotion: "",
          DescriptionAdvantages: "",
          DescriptionDisadvantages: "",
          InterviewProvince: "",
          InterviewCity: "",
          InterviewArae: "",
          InterviewAddress: "",
          InterviewTransportation: "",
          WorkTransportation: "",
          InterviewProcess: "",
          InterviewTips: "",
          PeriodEntry: "",
          IsNeedDeposit: "",
          ProcessTip: "",
          DemandAttachment: "",
          DemandAttachmentFileName: "",
          NumberGaps: "",
          DescriptioGapFile: "",
          RecruitmentStartTime: "",
          RecruitmentEenTime: "",
          EntryAttachmentFile: "",
          Lng: "",
          Lat: "",
          WorkAndDormitoryEnvironment: [],
          InterviewProvinceName: "",
          InterviewCityName: "",
          InterviewAraeName: "",
          Workingposition: "",
          WorkingShift: "",
          NationalityRequire: [],
          CertificateRequirements: "",
          DescriptionofSalary: "",
          BasicSalary: "",
          TemporarySupportStandard: "",
          MedicalExaminationReq: "",
          MedicalExaminationHospita: "",
          PhysicalExaminationFee: "",
          PhysicalExaminationFeeCondition: "",
          ProcedurePhysicalExamination: "",
          IncludeStay: "",
          EntryCity: "",
          EntryAddress: "",
          EntryAraeEntry: "",
          EntryProvince: "",
          WorkLng: '',
          WorkLat: '',
          ThroughTrainNot: '', //是否交通车
          SsPaymentMethodRemark: '', //社保备注
          PfPaymentMethodRemark: '', //公积金备注
          InterviewAddressDetailUrl: '', //面试地址详情url
        },
        workArea: '',
        InterviewfileList:[],//面试附件列表
        //环境图片列表
        PicList: [],
        addressType: '',
        rules: {
          ProjectId: {
            required: true,
            message: "请选择项目",
            trigger: ["blur", "change"],
          },
          LaborRelation: {
            required: true,
            message: "请选择劳动关系",
            trigger: "change",
          },
          JobType: {
            required: true,
            message: "请选择岗位属性",
            trigger: "change",
          },
          Workingposition: {
            required: true,
            message: "请选择站/坐班",
            trigger: "change",
          },
          JobCategory: {
            required: true,
            message: "请选择岗位类型",
            trigger: "change",
          },
          CustomerJobName: {
            required: true,
            trigger: "blur",
            validator: validatetJobName,
          },
          WorkingShift: {
            required: true,
            message: "请选择班次",
            trigger: "change",
          },
          NeedAmount: {
            required: true,
            message: "请输入需求人数",
            trigger: "blue",
          },
          UnpaidPeriod: {
            required: true,
            message: "请输入无薪资周期",
            trigger: "blue",
          },
          workCity: {
            required: true,
            validator: validatetCity,
            trigger: "change",
          },
          Degree: {
            required: true,
            message: "请选择学历要求",
            trigger: "change",
          },
          JobContent: {
            required: true,
            message: "请输入工作内容",
            trigger: "change",
          },
          Gender: {
            required: true,
            message: "请选择性别要求",
            trigger: "change",
          },
          NationalityRequire: {
            required: true,
            message: "请选择民族要求",
            trigger: "change",
          },
          age: {
            required: true,
            validator: validatetAge,
            trigger: "change"
          },
          PackageEat: {
            required: true,
            message: "请选择是否包吃",
            trigger: "change",
          },
          SocialSecurityPaymentMethod: {
            required: true,
            message: "请选择社保缴纳方式",
            trigger: "change",
          },
          CertificateRequirements: {
            required: true,
            validator: validatetCert,
            message: "请选择证书要求",
            trigger: "change",
          },
          ExperienceReq: {
            required: true,
            message: "请选择工作经验要求",
            trigger: "change",
          },
          AccumulationFundPaymentMethod: {
            required: true,
            message: "请选择公积金缴纳方式",
            trigger: "change",
          },
          PayType: {
            required: true,
            message: "请选择薪资类型",
            trigger: "change",
          },
          IncludeStay: {
            required: true,
            message: "请选择是否包住",
            trigger: "change",
          },
          SalaryAfterFullEmployment: {
            required: true,
            message: "请输入正式薪资标准",
            trigger: "blur",
          },
          ComprehensiveSalary: {
            required: true,
            validator: validatetSalary,
            trigger: "blur",
          },
          InterviewAddress: {
            required: true,
            validator: validatetInter,
            trigger: ["blur", "change"],
          },
          workAddress: {
            required: true,
            validator: validatetEntryAttachmentFileName,
            trigger: ["blur", "change"],
          },
          IsNeedDeposit: {
            required: true,
            message: "请选择是否需要押金",
            trigger: "change",
          },
          IsNeedDeposit: {
            required: true,
            message: "请选择是否需要押金",
            trigger: "change",
          },
          InterviewTips: {
            required: true,
            message: "请选择输入面试注意事项",
            trigger: "blur",
          },
          PhysicalExaminationFee: {
            required: true,
            message: "请选择体检费是否报销",
            trigger: "change",
          },
          MedicalExaminationReq: {
            required: true,
            message: "请选择体检要求",
            trigger: "change",
          },
          MethodOfPay: {
            required: true,
            message: "请选择发薪方式",
            trigger: "change",
          },
          SalaryduringProbationPeriod: {
            required: true,
            message: "请选择发薪方式",
            trigger: "blur",
          },
          PayDate: {
            required: true,
            message: "请输入发薪日",
            trigger: "blur"
          },
          UnpaidPeriodRemark: {
            required: true,
            message: "请输入无薪资备注",
            trigger: "blur",
          },
          IncludeStayEatRemark: {
            required: true,
            message: "请输入食宿备注",
            trigger: "blur",
          },
          NightShiftSubsidy: {
            required: true,
            message: "请输入夜班补贴",
            trigger: "blur",
          },
          OvertimeSubsidy: {
            required: true,
            message: "请输入加班补贴",
            trigger: "blur",
          },
          CompensationAndWelfareRemark: {
            required: true,
            message: "请输入备注",
            trigger: "blur",
          },
          WorkAndDormitoryEnvironment: {
            required: true,
            message: "请上传工作&宿舍环境",
            trigger: "change",
          },
          CycleTimetable: {
            required: true,
            message: "请输入排班周期",
            trigger: "blur",
          },
          MonthlyRest: {
            required: true,
            message: "请输入月休",
            trigger: "blur"
          },
          TrainCycle: {
            required: true,
            message: "请输入培训周期",
            trigger: "blur",
          },
          Trialperiod: {
            required: true,
            message: "请输入试工周期",
            trigger: "blur",
          },
          InterviewProcess: {
            required: true,
            message: "请输入面试流程",
            trigger: "blur",
          },
          ProcessTip: {
            required: true,
            message: "请输入入职流程/注意事项",
            trigger: "blur",
          },
          ProcedurePhysicalExamination: {
            required: true,
            message: "请输入体检流程/注意事项",
            trigger: "blur",
          },
        },
        dialogVisiblePic: false,
        projectpersondetails: {},
        dialogImageUrl: "",
        map: null, //地图控件
        marker: null, //地图点
        coordinate: null, //坐标点
        backupCoord: null, //用于备份
        lat: "",
        lng: "",
        addressName: "",
        addressList: [], //搜索地址返回的列表
        showAddressSelect: false, //搜索面试地址返回列表显隐
        showAddressSelect2: false, //搜索工作地址返回列表显隐
        visibleMap2: false,
        isEdit: "",
        provinces: [],
        marY: 0,
        marX: 0,
        workCity: "", //工作城市
        interAddress: "", //面试地区
        workAddress: "", //工作地区
        //工作城市
        propsCity: {
          lazy: true,
          value: "Id",
          label: "Name",
          // multiple: true,
          checkStrictly: true,
          lazyLoad(node, resolve) {
            console.log("node", node);
            const {
              value,
              level
            } = node;
            if (value && value != undefined) {
              xz.getArea(value).then((res) => {
                if (res.status == "ok") {
                  if (level === 2) {
                    resolve(
                      res.data.ret.map((item) => {
                        item.leaf = "leaf";
                        return item;
                      })
                    );
                  } else {
                    resolve(res.data.ret);
                  }
                } else {
                  this.$message.error("获取城市出错");
                }
              });
            }
          },
        },
        interviewOnline: false,
        propsAddress: {
          lazy: true,
          value: "Id",
          label: "Name",
          lazyLoad(node, resolve) {
            const {
              value,
              level
            } = node;
            if (value && value != undefined) {
              xz.getArea(value).then((res) => {
                if (res.status == "ok") {
                  if (level === 2) {
                    resolve(
                      res.data.ret.map((item) => {
                        item.leaf = "leaf";
                        return item;
                      })
                    );
                  } else {
                    resolve(res.data.ret);
                  }
                } else {
                  this.$message.error("获取城市出错");
                }
              });
            }
          },
        },
        cascaderCityShow: 0,
      };
    },
    created() {
      this.getproList();
      this.getprovinces(0);
      this.getTreestr();
      this.getdictdatalistbyid1();
      this.GetDictDataTreeListById(188, "certificate");
      let q = this.$route.query;
      if (q.proId && q.proId != undefined) {
        this.query.ProjectId = this.$route.query.proId;
        this.query.Id = this.$route.query.id;
        this.isEdit = this.$route.query.isEdit;
        if (this.isEdit) {
          this.getprojectpersondetails();
          this.getjobdetails();
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        // this.initMap();
      });
      if (this.Id) {
        this.query.Id = this.Id;
        // this.getjobdetails();
      }
      // let _this = this;
      // const hander = (event) => {
      //   console.log('监听中')
      //   this.foo(event)
      // }
      // document.addEventListener('click', hander)
      // this.$once("hook:beforeDestroy", () => document.removeEventListener('click', hander));
    },
    methods: {
      //点击其他地方，关闭地图和地址选择下拉框
      foo(e) {
        if (this.$refs.chickMap.contains(e.target) || this.$refs.chickBox1.contains(e.target) || this.$refs.chickBox.contains(e.target)) {
          //点击的该区域的
          return
        } else {
          //点击别的区域关闭地址选择器
          this.visibleMap = false;
          this.showAddressSelect2 = false;
          this.showAddressSelect = false;
        }
      },
      // 获取项目详情
      getprojectpersondetails() {
        xz.getprojectpersondetails(
          this.query.ProjectId,
          localStorage.loginRoletype
        ).then((res) => {
          console.log("ee", res);
          let r = res.data;
          if (res.status == "ok") {
            this.proDtl = {
              StrProManagerName: r.StrProManagerName, // 项目管理员
              StrProManagerMobile: r.StrProManagerMobile,
              StrservuserNname: r.StrservuserNname, // 客服
              ServiceDepName: r.ServiceDepName,
              StrservuserMobile: r.StrservuserMobile, // 客服手机号
            };
          } else {
            // this.$message.error("获取项目详情出错");
          }
        });
      },
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 1000,
          strIsDisable: "",
          keyword: "",
        };
        xz.getTreestr("JB_base_Jobcategory", data).then((res) => {
          if (res) {
            this.jobCategoryList = res.msg.parent;
          } else {
            this.jobCategoryList = [];
          }
        });
      },
      getproList() {
        let proNameQuery = {
          roletype: localStorage.loginRoletype,
          projectname: "",
          perpage: 10000,
          currpage: 1,
        };
        xz.getProjectLists(proNameQuery).then((res) => {
          if (res.status == "ok") {
            this.prolist = res.msg;
          } else {
            this.prolist = [];
          }
        });
      },
      // querySearch(queryString, cb) {
      //   let proNameQuery = {
      //     roletype: localStorage.loginRoletype,
      //     projectname: queryString,
      //     perpage: 10000,
      //     currpage: 1
      //   }
      //   xz.getProjectLists(proNameQuery).then(res => {
      //     if (res.status == 'ok') {
      //       var showSuggestion = document.getElementsByClassName("search-autocpmplete")[0];
      //       this.prolist = res.msg;
      //       this.$refs['pro'].focus();
      //       cb(res.msg);
      //       this.validatetPro
      //       if (res.msg.length) {
      //         showSuggestion.style.display = 'block'
      //       }
      //     } else {
      //       cb([])
      //     }
      //   })
      // },
      // handleSelect(item) {
      //   this.query.ProjectId = item.Projectid;
      //   this.$refs['pro'].focus();
      // },
      //获取省份
      getprovinces(parent) {
        xz.getArea(parent).then((res) => {
          if (res.status == "ok") {
            this.provinces = res.data.ret;
            // if (this.workCity.length > 0) {
            //   this.getCity(this.workCity[0], 1, 'provinces','query.WorkAreaName');
            // }
          } else {
            this.provinces = [];
          }
        });
      },
      getCity(code, lv, list, list2) {
        xz.getArea(code).then((res) => {
          if (res.status == "ok") {
            if (lv == 1) {
              this[list].forEach((ele, index) => {
                if (ele.Id === code) {
                  this.$set(this[list][index], "children", res.data.ret);
                  this.getCity(this[list2][1], 2, index);
                }
              });
            } else {
              this.provinces[list].children.forEach((ele, index) => {
                if (ele.Id === code) {
                  res.data.ret.map((item) => {
                    item.leaf = "leaf";
                  });
                  this.$set(
                    this.provinces[list].children[index],
                    "children",
                    res.data.ret
                  );
                }
              });
            }
          }
        });
      },
      //获取下拉选项
      getdictdatalistbyid(Id, list) {
        xz.getdictdatalistbyid(Id).then((res) => {
          if (res.status == "ok") {
            this[list] = res.data.retList;
          } else {
            this[list] = [];
          }
        });
      },
      //获取下拉选项1
      getdictdatalistbyid1() {
        let Id = "34,39,44,48,52,222,57,64,67,70,253,83,86,89,183";
        xz.getdictdatalistbyid(Id).then((res) => {
          if (res.status == "ok") {
            this["edu"] = res.data.retList.filter((item) => {
              return item.ParentId == 34;
            });
            this["workExp"] = res.data.retList.filter((item) => {
              return item.ParentId == 39;
            });
            this["stay"] = res.data.retList.filter((item) => {
              return item.ParentId == 44;
            });
            this["sex"] = res.data.retList.filter((item) => {
              return item.ParentId == 48;
            });
            this["sspm"] = res.data.retList.filter((item) => {
              return item.ParentId == 52;
            });
            this["gjj"] = res.data.retList.filter((item) => {
              return item.ParentId == 222;
            });
            this["eat"] = res.data.retList.filter((item) => {
              return item.ParentId == 57;
            });
            this["workOvertime"] = res.data.retList.filter((item) => {
              return item.ParentId == 64;
            });
            this["posture"] = res.data.retList.filter((item) => {
              return item.ParentId == 67;
            });
            this["classes"] = res.data.retList.filter((item) => {
              return item.ParentId == 70;
            });
            this["nation"] = res.data.retList.filter((item) => {
              return item.ParentId == 253;
            });
            this["unit"] = res.data.retList.filter((item) => {
              return item.ParentId == 83;
            });
            this["salaryType"] = res.data.retList.filter((item) => {
              return item.ParentId == 86;
            });
            this["labour"] = res.data.retList.filter((item) => {
              return item.ParentId == 89;
            });
            this["methodOfPay"] = res.data.retList.filter((item) => {
              return item.ParentId == 183;
            });
          } else {
            this[list] = [];
          }
        });
      },
      //获取多级下拉选项
      GetDictDataTreeListById(Id, list) {
        xz.GetDictDataTreeListById(Id).then((res) => {
          if (res.status == "ok") {
            this[list] = res.data.inf;
          } else {
            this[list] = [];
          }
        });
      },
      changeJob(val) {
        this.query.JobCategory = val[val.length - 1];
        console.log(val, this.query.JobCategory);
        this.$refs.cascader._data.dropDownVisible = false;
      },
      changeCert(val) {
        console.log(this.query.CertificateRequirements);
        // this.query.CertificateRequirements = val[val.length - 1];
        // console.log(val, this.query.CertificateRequirements);
        // this.$refs.certificate._data.dropDownVisible = false;
      },
      //上传岗位描述附件
      handleChangeDes(file, fileList) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.query.DemandAttachmentFileName = file.name;
            this.query.DemandAttachment = res;
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      handleExceed() {
        this.$message.warning(`当前限制选择上传 1 个文件`);
      },
      handleRemoveDes(file, fileList) {
        this.query.DemandAttachment = "";
      },
      selectChange() {
        // console.log(this.query.Degree1)
      },
      handleChangePic(file) {
        let maxSize = 1024 * 1024 * 5;
        if (file.size <= maxSize) {
          this.uploadImg(file.raw);
        } else {
          xz.imgCompress(file.raw).then((f) => {
            if (f) {
              this.uploadImg(f)
            }
          });
        }
      },
      uploadImg(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file, file.name);
        xz.uploadCert(formData).then((res) => {
          console.log("entPicFile", res);
          if (res) {
            this.query.WorkAndDormitoryEnvironment.push({
              id: "",
              url: res,
            });
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      //图片预览
      handlePictureCardPreview(file) {
        console.log(file);
        this.dialogImageUrl = file.url;
        this.dialogVisiblePic = true;
        // if (file.url.indexOf('blob') > -1) {
        //   this.dialogImageUrl = file.url;
        //   this.dialogVisiblePic = true;
        // }else{
        //   let head = 'http://emp.joball.net/cloudimg/';
        //   this.dialogImageUrl = head + file.url;
        //   this.dialogVisiblePic = true;
        // }
      },
      //删除图片
      handleRemovePic(file, fileList) {
        console.log(file, fileList);
        this.query.WorkAndDormitoryEnvironment.forEach((ele, index) => {
          if ((ele) => file.Id === ele.Id) {
            this.query.WorkAndDormitoryEnvironment.splice(index, 1);
          }
        });
        console.log(this.query.WorkAndDormitoryEnvironment);
      },
      handleExceedPic() {
        this.$message.warning(`最多上传9张图片！`);
      },
      //上传需求描述附件
      handleChangeDemFile(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.query.DemandAttachmentFileName = file.name;
            this.query.DemandAttachment = res;
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      handleRemoveDemFile(file, fileList) {
        this.query.DemandAttachmentFileName = "";
        this.query.DemandAttachment = "";
      },
      //上班地址附件
      handleChangeAddress(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.query.EntryAttachmentFileName = file.name;
            this.query.EntryAttachmentFile = res;
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      handleRemoveAddress() {
        this.query.EntryAttachmentFileName = "";
        this.query.EntryAttachmentFile = "";
      },
      //上传面试附件
      handleChangeInterview(file){
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "bdocinf");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.query.InterviewAddressDetailUrl = res;
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      handleRemoveInterview() {
        this.query.EntryAttachmentFile = "";
      },
      //选择限制区域
      changeLimitProvinceName(index) {
        let city = this.$refs.LimitProvinceName[index].getCheckedNodes(true)[0];
        if (city != undefined && city) {
          let name = city.pathLabels
            .toString()
            .replace(",", "-")
            .replace(",", "-");
          this.query.LimitProvinceName[index] = {
            name: name,
          };
          // this.$nextTick(()=>{
          //   this.$refs[`LimitProvinceName`][index].inputValue = city.pathLabels.toString().replace(',', '-').replace(',', '-');
          // })
          this.$refs.LimitProvinceName[index]._data.dropDownVisible = false;
        } else {
          this.query.LimitProvinceName[index] = "";
        }
        console.log(this.query.LimitProvinceName);
      },
      //移除限制区域
      removeLimitProvinceName(index) {
        if (index !== -1) {
          this.query.LimitProvinceName.splice(index, 1);
        }
      },
      removeAttendanceTime(index) {
        if (index !== -1) {
          this.query.AttendanceTime.splice(index, 1);
        }
      },
      addLimitProvinceName() {
        this.query.LimitProvinceName.push({
          name: "",
        });
      },
      //添加上班时间
      addAttendanceTime() {
        this.query.AttendanceTime.push({
          startTime: "",
          endTime: "",
        });
      },
      //选择城市
      changeCity(val) {
        let city = this.$refs.workCity.getCheckedNodes(true)[0];
        switch (city.level) {
          case 1:
            this.query.WorkProvince = city.value;
            this.query.WorkProvinceName = city.label;

            this.query.WorkCity = "";
            this.query.WorkCityName = "";
            this.query.WorkAreaName = "";
            this.query.WorkAreaName = "";
            break;
          case 2:
            this.query.WorkProvince = city.parent.value;
            this.query.WorkProvinceName = city.parent.label;
            this.query.WorkCity = city.value;
            this.query.WorkCityName = city.label;

            this.query.WorkAreaName = "";
            this.query.WorkAreaName = "";
            break;
          case 3:
            this.query.WorkProvince = city.parent.parent.value;
            this.query.WorkProvinceName = city.parent.parent.label;
            this.query.WorkCity = city.parent.value;
            this.query.WorkCityName = city.parent.label;
            this.query.WorkAreaName = city.value;
            this.query.WorkAreaName = city.label;
            break;
        }
        // console.log(this.workCity, city)
      },
      //选择面试地址
      changeInterviewArae(val) {
        let city = this.$refs.InterviewAddress.getCheckedNodes(true)[0];
        if (city.level == 2) {
          this.query.InterviewProvince = city.parent.value;
          this.query.InterviewProvinceName = city.parent.label;
          this.query.InterviewCity = city.value;
          this.query.interviewCityName = city.label;
          this.query.InterviewArae = "";
          this.query.InterviewAraeName = "";
          this.query.InterviewAddress = "";
          // this.blurSearch('inter');
        } else {
          this.query.InterviewProvince = city.parent.parent.value;
          this.query.InterviewProvinceName = city.parent.parent.label;
          this.query.InterviewCity = city.parent.value;
          this.query.interviewCityName = city.parent.label;
          this.query.InterviewArae = city.value;
          this.query.InterviewAraeName = city.label;
          this.query.InterviewAddress = "";
          // this.blurSearch('inter');
        }
        // this.visibleMap = true;
        console.log(
          "s",
          this.query.interviewProvinceName,
          this.query.interviewProvinceName,
          this.query.InterviewAraeName
        );
      },
      //选择上班地址
      changeWorkArea(val) {
        let city = this.$refs.workAddress.getCheckedNodes(true)[0];

        if (city.level == 2) {
          this.query.EntryProvince = city.parent.label;
          this.query.EntryCity = city.label;
          this.query.EntryAraeEntry = "";
          this.workArea = city.value;
          // this.blurSearch('work');
        } else {
          this.query.EntryProvince = city.parent.parent.label;
          this.query.EntryCity = city.parent.label;
          this.query.EntryAraeEntry = city.label;
          this.workArea = city.value;
          // this.blurSearch('work');
        }
      },
      //失去焦点获取数据
      blurSearch(type) {
        if (type == 'inter') {
          //有值才搞
          if (this.query.InterviewArae && !this.query.lat && !this.query.lng) {
            this.fixMarker(this.query.InterviewArae ? this.query.InterviewArae : InterviewCity, 'inter');
          }
        } else {
          //有值才搞
          if (this.workArea && !this.query.WorkLng && !this.query.WorkLat) {
            this.fixMarker(this.workArea, this.workArea, 'work');
          }
        }
      },
      //固定点
      fixMarker(code, type) {
        const store = this.$store.getters;
        let address = store.codeToggleObj(code);
        let addressName = store.localName(address, ","); //名称
        if (type == 'work') {
          addressName += "," + this.query.EntryAddress;
        } else {
          addressName += "," + this.query.InterviewAddress;
        }
        const _this = this;
        let geocoder = new qq.maps.Geocoder();
        geocoder.getLocation(addressName);
        geocoder.setComplete((result) => {
          let detail = result.detail;
          let coordinate = detail.location; //坐标
          if (type == 'inter') {
            _this.query.lat = coordinate.lat;
            _this.query.lng = coordinate.lng;
          } else {
            _this.query.WorkLng = coordinate.lat;
            _this.query.WorkLat = coordinate.lng;
          }
          _this.backupCoord = _this.coordinate = coordinate; //保存坐标点
          _this.map.setCenter(coordinate); //移动地图中心
          _this.marker.setPosition(coordinate);
        });
      },
      //根据当前的地址换算坐标点
      toggleCoordinate(code) {
        const _this = this;
        const store = this.$store.getters;
        let address = store.codeToggleObj(code);
        let addressName = store.localName(address, ","); //名称
        if (this.query.InterviewAddress)
          addressName += "," + this.query.InterviewAddress;
        let geocoder = new qq.maps.Geocoder();
        geocoder.getLocation(addressName);
        geocoder.setComplete(function (result) {
          let detail = result.detail;
          let coordinate = detail.location; //坐标
          _this.query.lat = coordinate.lat;
          _this.query.lng = coordinate.lng;
          _this.query.InterviewAddress = store.localName(address);
        });
      },
      //创建腾讯地图
      initMap() {
        const _this = this;
        const mapContainer = document.getElementById("mapSelector");
        let initLatLng = new qq.maps.LatLng(_this.lat, _this.lng);
        let myOptions = {
          zoom: 15,
          center: initLatLng,
          panControl: false, //平移控件
          zoomControl: false, //缩放控件
          mapTypeControl: false, //地图类型
        };
        this.map = new qq.maps.Map(mapContainer, myOptions);
        //设置标记点
        this.marker = new qq.maps.Marker({
          position: initLatLng,
          map: this.map,
        });
        qq.maps.event.addListener(_this.map, "click", function (e) {
          let coord = e.latLng;
          _this.coordinate = coord;
          _this.marker.setPosition(coord);
        });
        let resetBounds = function () {
          var bounds = _this.map.getBounds(); //获取函数范围
        };
        qq.maps.event.addListener(_this.map, 'click', function (evt) {
          console.log(evt)
          var lat = evt.latLng.getLat().toFixed(6);
          var lng = evt.latLng.getLng().toFixed(6);
          _this.getNearby(lat, lng)
        });
        //拖拽结束后触发
        qq.maps.event.addListener(_this.map, "dragend", resetBounds);
        //地图缩放时触发
        qq.maps.event.addListener(_this.map, "zoom_changed", resetBounds);
        //自定义控件
        let focus = document.createElement("div");
        focus.className = "focusBtn";
        //将控件添加到controls栈变量并将其设置在顶部位置
        this.map.controls[qq.maps.ControlPosition.LEFT_BOTTOM].push(focus);
        focus.addEventListener("click", function () {
          _this.coordinate = _this.backupCoord; //保存坐标点
          if (_this.marker) {
            _this.map.setCenter(_this.backupCoord); //移动地图中心
            _this.marker.setPosition(_this.backupCoord);
          }
        });
      },
      submitForm() {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.query.NationalityRequire =
              this.query.NationalityRequire.toString();
            if (this.CertificateRequirements) {
              let str = "";
              this.CertificateRequirements.forEach((element, index) => {
                str =
                  index == 0 ?
                  element[0] + "-" + element[1] :
                  str + "," + element[0] + "-" + element[1];
                if (index + 1 == this.CertificateRequirements.length) {
                  this.query.CertificateRequirements = str;
                  // console.log('ad',this.query.CertificateRequirements)
                }
              });
            }
            if (this.query.DepositType) {
              let DepositTypelist = this.query.DepositType.toString();
              let hasother = DepositTypelist.indexOf("其他") > -1;
              if (this.otherDepositType) {
                //押金类型勾选了'其他'
                if (!hasother) {
                  let DepositType = "其他：" + this.DepositType;
                  this.query.DepositType.push(DepositType);
                } else {
                  this.query.DepositType.forEach((element, index) => {
                    if (element.indexOf("其他") > -1) {
                      let DepositType = "其他：" + this.DepositType;
                      this.query.DepositType[index] = DepositType;
                    }
                  });
                }
              }
              this.query.DepositType = this.query.DepositType.toString();
            }
            if (this.query.Degree1) {
              this.query.Degree1 = this.query.Degree1.toString();
            }
            let LimitProvinceName = this.query.LimitProvinceName;
            // query.AttendanceTime = JSON.stringify(this.query.AttendanceTime);
            if (LimitProvinceName) {
              // this.query.LimitProvinceName = JSON.stringify(
              //   this.query.LimitProvinceName
              // );
              let str = '';
              LimitProvinceName.forEach((element, index) => {
                str = index == 0 ? element.name : str + ',' + element.name
                if (index + 1 == LimitProvinceName.length) {
                  LimitProvinceName = str
                }
              });
            }
            let AttendanceTime = this.query.AttendanceTime;
            if (AttendanceTime) {
              let str = '';
              AttendanceTime.forEach((element, index) => {
                str = index == 0 ? element.startTime + '-' + element.endTime : str + ',' + element.startTime + '-' + element.endTime
                if (index + 1 == AttendanceTime.length) {
                  AttendanceTime = str
                }
              });
            }
            let query = this.query;
            query.LimitProvinceName = LimitProvinceName;
            query.AttendanceTime = AttendanceTime;
            if (this.interviewOnline) {
              this.query.InterviewProvinceName = '线上面试'
            }
            // console.log(AttendanceTime,this.query.AttendanceTime);
            xz.jobeditorsave(query, localStorage.loginRoletype).then((res) => {
              if (res.status == "ok") {
                this.query.Id = res.data;
                console.log("data", res.data);
                this.$emit("Id", res.data);
              } else {
                if (!this.isNull(this.query.NationalityRequire)) {
                  this.query.NationalityRequire = this.query.NationalityRequire.split(",");
                }
                this.query.CertificateRequirements = '';
                if (!this.isNull(this.query.DepositType)) {
                  this.query.DepositType = this.query.DepositType.split(",");
                }
                if (!this.isNull(this.query.Degree1)) {
                  this.query.Degree1 = this.query.Degree1.split(",");
                }
                if (this.query.LimitProvinceName != undefined && this.query.LimitProvinceName) {
                  let arr = this.query.LimitProvinceName.split(",");
                  let arr2 = [];
                  arr.forEach((element, index) => {
                    let obj = {
                      name: element
                    }
                    arr2.push(obj)
                    if (arr.length == index + 1) {
                      this.query.LimitProvinceName = arr2
                    }
                    this.$nextTick(() => {
                      this.$refs[`LimitProvinceName`][index].inputValue =
                        element;
                    });
                  })
                } else {
                  this.query.LimitProvinceName = [{
                    name: ''
                  }]
                }

                let arr = this.query.AttendanceTime.split(",");
                let arr2 = [];
                arr.forEach((element, index) => {
                  let startTime = element.split("-")[0];
                  let endTime = element.split("-")[1];
                  let obj = {
                    startTime: startTime,
                    endTime: endTime
                  }
                  arr2.push(obj)
                  if (arr.length == index + 1) {
                    this.query.AttendanceTime = arr2
                  }
                })

                this.$message.error(res.msg);
              }
            });
          } else {
            this.$message.warning("您有必填项没有填写");
            this.$nextTick(() => {
              let isError = document.getElementsByClassName("is-error");
              isError[0].scrollIntoView({
                // 滚动到指定节点
                // 值有start,center,end，nearest，当前显示在视图区域中间
                block: "center",
                // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                behavior: "smooth",
              });
            });
            console.log("error submit!!");
            return false;
          }
        });
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      },
      changeNav(val) {
        console.log("sd", val, this.query.NationalityRequire);
      },
      getjobdetails() {
        xz.getjobdetails(this.query.Id).then((res) => {
          let r = JSON.parse(res);
          if (r.status == "ok") {
            // this.projectperson(r.data.ProjectId);
            this.query = r.data;
            if (this.query.IsOverTime) {
              this.query.IsOverTime = r.data.IsOverTime == "true" ? true : false;
            }
            if (this.query.PayforTraining) {
              this.query.PayforTraining =
                r.data.PayforTraining == "true" ? true : false;
            }
            if (this.query.TrialWorkisPaid) {
              this.query.TrialWorkisPaid =
                r.data.TrialWorkisPaid == "true" ? true : false;
            }
            if (this.query.AcceptDisabled) {
              this.query.AcceptDisabled =
                r.data.AcceptDisabled == "true" ? true : false;
            }
            if (r.data.CertificateRequirements) {
              r.data.CertificateRequirements =
                r.data.CertificateRequirements.split(",");
              let arr = [];
              r.data.CertificateRequirements.forEach((element, index) => {
                arr.push(element.split("-"));
                if (index + 1 == r.data.CertificateRequirements.length) {
                  this.CertificateRequirements = arr;
                }
              });
            }
            if (r.data.StrprojectName != undefined && r.data.StrprojectName) {
              this.projectname = r.data.StrprojectName;
            }
            if (r.data.Degree1 != undefined) {
              this.query.Degree1 = r.data.Degree1.split(",");
            }
            if (r.data.DepositType != undefined) {
              this.query.DepositType = r.data.DepositType.split(",");
              this.query.DepositType.forEach((element) => {
                if (element.indexOf("其他") > -1) {
                  this.otherDepositType = true;
                  this.DepositType = element.split("：")[1];
                }
              });
            }
            if (
              r.data.NationalityRequire != undefined &&
              r.data.NationalityRequire
            ) {
              this.query.NationalityRequire =
                r.data.NationalityRequire.split(",");
            }
            if (
              r.data.LimitProvinceName != undefined &&
              r.data.LimitProvinceName
            ) {
              // this.query.LimitProvinceName = JSON.parse(r.data.LimitProvinceName);
              let arr = r.data.LimitProvinceName.split(",");
              let arr2 = [];
              arr.forEach((element, index) => {
                let obj = {
                  name: element
                }
                arr2.push(obj)
                if (arr.length == index + 1) {
                  this.query.LimitProvinceName = arr2
                }
                this.$nextTick(() => {
                  this.$refs[`LimitProvinceName`][index].inputValue =
                    element;
                });
              })
              // this.query.LimitProvinceName.forEach((element, index) => {
              //   this.$nextTick(() => {
              //     this.$refs[`LimitProvinceName`][index].inputValue =
              //       element.name;
              //   });
              // });
            } else {
              this.query.LimitProvinceName = [{
                name: ''
              }]
            }
            if (r.data.AttendanceTime != undefined && r.data.AttendanceTime) {
              // this.query.AttendanceTime = JSON.parse(r.data.AttendanceTime);
              let arr = r.data.AttendanceTime.split(",");
              let arr2 = [];
              arr.forEach((element, index) => {
                let startTime = element.split("-")[0];
                let endTime = element.split("-")[1];
                let obj = {
                  startTime: startTime,
                  endTime: endTime
                }
                arr2.push(obj)
                if (arr.length == index + 1) {
                  this.query.AttendanceTime = arr2
                }
              })
            }
            this.workCity = "";
            this.workCity = r.data.WorkProvinceName;
            this.workCity = r.data.WorkCityName ?
              this.workCity + "-" + r.data.WorkCityName :
              this.workCity;
            this.workCity = r.data.WorkAreaName ?
              this.workCity + "-" + r.data.WorkAreaName :
              this.workCity;
            this.$nextTick(() => {
              this.$refs[`workCity`].inputValue = this.workCity;
            });
            // this.workCity.push(Number(r.data.WorkProvinceName));
            // r.data.WorkCityName && r.data.WorkCityName != null ? this.workCity.push(Number(r.data.WorkCityName)) : '';
            // r.data.WorkAreaName && r.data.WorkAreaName != null ? this.workCity.push(Number(r.data.WorkAreaName)) : '';
            // this.workCity.join(',');
            if (r.data.InterviewProvinceName == '线上面试') {
              this.interviewOnline = true;
            } else {
              this.interAddress = "";
              this.interAddress =
                r.data.InterviewProvinceName + "-" + r.data.InterviewCityName;
              this.interAddress = r.data.InterviewAraeName ?
                this.interAddress + "-" + r.data.InterviewAraeName :
                this.interAddress;
              this.$nextTick(() => {
                this.$refs[`InterviewAddress`].inputValue = this.interAddress;
              });
            }
            // this.interAddress = [];
            // this.interAddress.push(r.data.InterviewProvince);
            // this.interAddress.push(r.data.InterviewCity);
            // this.interAddress.push(r.data.InterviewArae);
            // this.interAddress.join(',');

            // this.getCity(this.workCity[0], 1, 'provinces', 'workCity');
            // this.getCity(this.interAddress[0], 1, 'provinces', 'interAddress');
            if (r.data.EntryProvince) {
              let workAddress = "";
              workAddress = r.data.EntryProvince + "-" + r.data.EntryCity;
              workAddress = r.data.EntryAraeEntry ?
                workAddress + "-" + r.data.EntryAraeEntry :
                workAddress;
              this.$nextTick(() => {
                this.$refs[`workAddress`].inputValue = workAddress;
              });
              this.workAddress = workAddress;
            }
            this.blurSearch('inter');
            const head =
              location.origin.indexOf("localhost") > -1 ?
              "https://dev.joball.net/clouddoc/" :
              location.origin + "/clouddoc/";
            if (r.data.DemandAttachment && r.data.DemandAttachment != null) {
              let item = {
                name: r.data.DemandAttachmentFileName,
                url: head + r.data.DemandAttachment,
              };
              this.JobDesfileList.push(item);
            }
            if (r.data.DemandAttachment && r.data.DemandAttachment != null) {
              let item = {
                name: r.data.DemandAttachmentFileName,
                url: head + r.data.DemandAttachment,
              };
              this.DemfileList.push(item);
            }
            if (
              r.data.EntryAttachmentFile &&
              r.data.EntryAttachmentFile != null
            ) {
              let item = {
                name: r.data.EntryAttachmentFileName,
                url: head + r.data.EntryAttachmentFile,
              };
              this.addressfileList.push(item);
            }
            if (
              r.data.InterviewAddressDetailUrl &&
              r.data.InterviewAddressDetailUrl != null
            ) {
              let item = {
                name:'面试地址附件',
                url: head + r.data.InterviewAddressDetailUrl,
              };
              this.InterviewfileList.push(item);
            }
            if (this.query.WorkAndDormitoryEnvironment.length > 0) {
              this.PicList = [];
              this.query.WorkAndDormitoryEnvironment.forEach((element) => {
                let item = {
                  Id: element.Id,
                  url: head + element.Url,
                };
                this.PicList.push(item);
              });
            }
            console.log("o", this.query, this.PicList);
          } else {
            this.$message.error("获取需求详情出错");
          }
        });
      },
      //校验岗位名称
      checkJobName(chkval, callback) {
        if (chkval.length > 0) {
          let data = {
            Id: this.query.Id,
            ProjectId: this.query.ProjectId,
            CustomerJobName: chkval,
            JobCategory: this.query.JobCategory,
          };
          xz.jobeditorsavecheck(data, localStorage.loginRoletype).then((res) => {
            if (res.status == "ok") {
              callback(true);
            } else {
              callback(false);
            }
          });
        }
      },
      selectPro() {
        if (this.query.ProjectId) {
          this.getprojectpersondetails(
            this.query.ProjectId,
            localStorage.loginRoletype
          );
        }
      },
      // 取消
      backHandle() {
        this.$router.push({
          path: "/recruitDemand",
        });
      },
      //选择地址
      selectInterviewAddress(item) {
        if (this.addressType == 'work') {
          this.query.EntryAddress = item.title
          this.query.WorkLat = item.location.lat;
          this.query.WorkLng = item.location.lng;
          this.showAddressSelect2 = false;
        } else {
          this.query.InterviewAddress = item.title
          this.query.lat = item.location.lat;
          this.query.lng = item.location.lng;
          this.showAddressSelect = false;
        }
        const _this = this;
        let geocoder = new qq.maps.Geocoder();
        geocoder.getLocation(item.address);
        geocoder.setComplete((result) => {
          let detail = result.detail;
          let coordinate = detail.location; //坐标
          _this.backupCoord = _this.coordinate = coordinate; //保存坐标点
          _this.map.setCenter(coordinate); //移动地图中心
          _this.marker.setPosition(coordinate);
        });
      },
      setMapTab(lat, lng) {
        let coordinate = {
          lat,
          lng
        }
        this.map.setCenter(coordinate); //移动地图中心
        this.marker.setPosition(coordinate);
      },
      //获取周边地点
      getNearby(lat, lng) {
        
      },
      changeInterviewOnline(val) {
        console.log(val)
        this.interAddress = '';
        this.query.InterviewAddress = '';
        this.query.InterviewProvince = '';
        this.query.InterviewProvinceName = '';
        this.query.InterviewCity = '';
        this.query.interviewCityName = '';
        this.query.InterviewArae = "";
        this.query.InterviewAraeName = "";
        this.query.InterviewAddress = "";
      }
    },
  };
</script>
<style scoped>
  .empty {
    color: #ccc;
    text-align: center;
  }

  .addressSelect {
    position: absolute;
    top: 40px;
    background: #fff;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    max-height: 200px;
    width: 300px;
    overflow: auto;
    padding: 10px 0;
    z-index: 2000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  .addressSelectItem {
    padding: 0 0 0 10px;
  }

  .addressSelectItem:hover {
    background: #F5F7FA;
  }

  .remake {
    color: #AAAAAA;
    margin-left: 10px;
    font-size: 12px;
  }

  .r_info_dtl {
    font-size: 14px;
    /* color: #19bd92; */
    color: #333;
    font-weight: bold;
    display: flex;
    justify-content: flex-end;
  }

  .f_form {
    border-bottom: 1px solid #ddd;
  }

  .info_Item_Title {
    line-height: 33px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑, sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    margin-right: 100px;
  }

  .p_plan_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 14px;
  }

  .p_plan_title {
    margin-right: 12px;
  }

  .p_plan_right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .p_plan_upload {
    display: flex;
    align-items: baseline;
    min-width: 150px;
  }

  .crossbar {
    margin: 0 10px;
  }

  .btnBox {
    padding: 20px 0 50px 0;
    width: 98%;
    display: flex;
    justify-content: center;
  }

  .addnewdepart {
    width: 108px;
    text-align: right;
    color: #19bd92;
  }

  /* .PayDate{
  width: 150px;
} */
  .PayDateUnit {
    width: 15px;
  }

  .UnpaidPeriodUnit {
    width: 25px;
  }

  .zhi {
    padding: 0 5px;
  }

  .textarea {
    width: 100%;
  }

  .mapContainer {
    position: fixed;
    z-index: 9999;
  }
</style>

<style>
  .address #locDetail {
    width: 300px !important;
  }

  .demandForm .el-input__inner {
    width: 150px;
    height: 32px;
    line-height: 32px;
    padding-left: 10px;
    padding-right: 5px;
  }

  .age .el-input__inner {
    width: 60px;
    height: 32px;
    line-height: 32px;
  }

  .age .el-input {
    width: 60px;
  }

  .demandForm .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .demandForm .el-radio {
    line-height: 32px;
    margin-right: 15px;
  }

  .demandForm .el-form--inline .el-form-item {
    margin-right: 0px;
  }

  .demandForm .el-form-item {
    margin-bottom: 8px;
  }

  .demandForm .el-form-item__label {
    padding: 0;
  }

  .demandForm .el-form-item__error {
    top: 34px;
  }

  .demandForm .textarea .el-form-item__error {
    top: 100%;
  }

  .demandForm .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 88px;
  }

  .demandForm .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
  }

  /* .demandForm .el-cascader .el-input .el-input__inner {
  height: 32px !important;
  line-height: 32px;
} */

  .address .el-cascader .el-input .el-input__inner {
    height: 32px !important;
    line-height: 32px;
    width: 210px;
  }

  .mintextarea .el-textarea__inner {
    width: 350px;
  }

  .unitPrice .el-input__inner {
    width: 70px;
  }

  .trigger_select {
    height: 32px !important;
    line-height: 32px !important;
  }

  .PayDate .el-input__inner {
    width: 135px !important;
  }

  .UnpaidPeriod .el-input__inner {
    width: 125px !important;
  }

  .AttendanceTime .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 90px !important;
  }

  .AttendanceTime .el-input__inner {
    width: 90px !important;
  }

  .AttendanceTime .el-icon-time {
    display: none;
  }

  .DepositType .el-radio-group {
    width: 270px !important;
  }

  .Workingposition .el-radio-group {
    width: 150px !important;
  }

  .textarea .el-textarea__inner {
    width: 100% !important;
    padding-left: 10px !important;
  }

  .textarea .el-form-item__content {
    width: calc(100% - 120px) !important;
  }

  .Degree .el-checkbox {
    margin-right: 10px !important;
  }

  .Degree .el-checkbox__label {
    padding-left: 5px;
  }

  .Degree1 .el-checkbox-group {
    width: 270px !important;
  }

  .certificate .el-input__inner {
    height: 32px !important;
  }

  .WorkAndDormitoryEnvironment .el-form-item__error {
    top: 80px !important;
  }

  .TrainCycle .el-form-item__error {
    top: 100% !important;
  }

  .locDetailSeach {
    padding: 0 15px;
    height: 32px;
    line-height: 32px;
    margin-top: 4px;
    margin-left: 10px;
  }
</style>